import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import { withNamespaces } from 'react-i18next';


const NotFoundPage = (props) => (
    <div>
        <Row type='flex' justify='center' align='middle'>
            <Col span={8} style={{ textAlign: 'center', margin: '8em 0' }}>
                <h1 style={{ fontSize: '48px' }}>
                    {props.i18n.t('NamespaceNotFound:Page not found')}
                </h1 >
                <h3 style={{ fontSize: '24px', margin: '0 0 24px 0' }}>
                    {props.i18n.t('NamespaceNotFound:Nothing to see here')}
                </h3>
                <Link to='/'>{props.i18n.t('NamespaceNotFound:Take me home')}</Link>
            </Col>
        </Row>
    </div>
);

export const NotFound = withNamespaces()(NotFoundPage);



// WEBPACK FOOTER //
// ./src/containers/Static/NotFound/index.js